import { render } from "./FormTextarea.vue?vue&type=template&id=93a976ec"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import "./FormTextarea.vue?vue&type=style&index=0&id=93a976ec&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__